









































import { Component, Prop, Ref, Mixins } from "vue-property-decorator";

import ProgressScore from "@/components/ReportResultTable/Progress.vue";

import ReportsMixin from "./Reports.mixin";

import { ILevelReportUser } from "@/models/interfaces/report-generator";

@Component({
  components: {
    ProgressScore
  }
})
export default class UnitReport extends Mixins<
  ReportsMixin<ILevelReportUser[]>
>(ReportsMixin) {
  @Prop({ required: true, type: Number })
  private level!: number;

  @Prop({ required: true, type: Number })
  private unit!: number;

  private get computedData() {
    return this.reportData.map(({ percentages, ...other }) => ({
      ...other,
      correct: percentages.correct,
      progress: percentages.progress
    }));
  }

  private get tableColumns() {
    return [
      {
        value: "firstname",
        label: "First name"
      },
      {
        value: "lastname",
        label: "Last name"
      },
      {
        value: "username",
        label: "Username"
      },
      {
        value: "correct",
        label: "Correct",
        name: "correct",
        custom: true
      },
      {
        value: "progress",
        label: "Completed",
        name: "completed",
        custom: true
      },
      {
        value: "chart",
        label: `Level ${this.level}, Unit ${this.unit}`,
        name: "chart",
        custom: true
      }
    ];
  }

  private generateCsvFile() {
    const headers = {
      username: "Username",
      firstname: "First name",
      lastname: "Last name",
      correct: "Correct",
      progress: "Completed"
    };
    const data = (this.computedData || []).map(
      ({ userId, correct, progress, ...other }) => ({
        ...other,
        correct: `${correct}%`,
        progress: `${progress}%`
      })
    );

    this.exportCSVFile(headers, data, this.title);
  }
}
